import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSalaryPaymentReport,
  fetchReportEmployees,
} from "./SalaryPaymentReportThunk";

const initialState = {
  list: [],
  employees: [],
  loading: false,
  filters: {
    filterType: "All",
    recordType: "without details",
    fromDate: null,
    toDate: null,
    employeeId: null,
    userId: null,
  },
};

const salaryPaymentReportSlice = createSlice({
  name: "salaryPaymentReport",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalaryPaymentReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSalaryPaymentReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchSalaryPaymentReport.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchReportEmployees.pending, (state) => {
        state.loadingEmployees = true;
      })
      .addCase(fetchReportEmployees.fulfilled, (state, action) => {
        state.loadingEmployees = false;
        state.employees = action.payload;
      })
      .addCase(fetchReportEmployees.rejected, (state) => {
        state.loadingEmployees = false;
      });
  },
});

export const { setFilters } = salaryPaymentReportSlice.actions;
export default salaryPaymentReportSlice.reducer;
